import { KoIf } from "@/index"

/**
 * @deprecated Use `KoIf` instead. This component will be removed in a future version.
 */
export const KoIfComment = KoIf
